import { connect } from 'react-redux'
import * as action from "../state/action";
import WhatsappMessages from "./WhatsappMessages";
import * as instanceDetailSelector from '../../process/state/instance-detail/selector';
import * as selector from '../state/selector';

const mapStateToProps = (state) => {
    return {
        processInstanceId: instanceDetailSelector.selectProcessInstanceId(state),
        whatsappMessageList: selector.selectWhatsappMessageList(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.findWhatsappMessageList
}

export default connect(mapStateToProps, mapDispatchToProps)(WhatsappMessages)



// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/component/WhatsappMessagesWidgetContainer.js